

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { checkCRUDViewPermission } from '../../../../../helpers/utilities';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import { TaxForm, SetupList } from "./Blocks";
import gstActions from "../../../../Admin/Setup/redux/actions";


const TaxSetupCreate = (props) => {
    const { countryDetails } = useSelector(state => state.addressReducer);
    const { readDetails } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const [showDetails, setShowDetails] = useState(true);
    const { type } = useParams();
    const formRef = useRef('');
    const setupRef = useRef('');

    const childRef = useRef('');
    const dispatch = useDispatch();
    let { taxId } = useParams();
    const decryptedId = AESDecrypt(taxId);
    const prevReadDetails = usePrevious(readDetails);

    useEffect(() => {
        if (taxId !== undefined && decryptedId === 0) {
            history.push('/younote-admin/common/tax-setup');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Tax Setup', type, history, 'Younote Admin')) {
            loadTask();
        }
    }, [taxId, type, roleManagement]);


    const loadTask = () => {
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id  desc'
            }
        });
        if (taxId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "country-taxes" });
        }
        childRef?.current?.handleAdjustHeight();
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }



    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            formRef.current.onEdit(readDetails);
            setupRef.current.onLoad(readDetails);
            setShowDetails(false);
            childRef?.current?.handleAdjustHeight();
        }
    }, [readDetails]);

    const classes = customStyles();

    return (
        <React.Fragment>
            <MainHeader
                {...props}
                img={SettingsImg}
                title={'Tax Setup'}
                links={[{ 'label': 'Home', 'link': '/' },
                { 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Tax Setup', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={`Tax Setup`}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <TaxForm
                                ref={formRef}
                                countryDetails={countryDetails}
                                clsx={clsx}
                                classes={classes}
                                type={type}
                                history={history}
                                taxId={decryptedId}
                                customObject={(details, id) => customObject(details, id)}
                            />
                        }
                    />
                    <CustomAccordion
                        title={`Setup`}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={type === 'create' && showDetails ?
                            <div className={classes.textAlignCenter}>Please Create Country Setup</div> :
                            <SetupList customObject={(details, id) => customObject(details, id)} ref={setupRef} readDetails={readDetails} roleManagement={roleManagement} countryId={readDetails.countryId} />
                        }
                    />
                    <CustomAccordion
                        title={'Third Party Service Settings'}
                        top={"113"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={showDetails}
                        index={2}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

export default TaxSetupCreate;